import { BaseComponent } from "./base";

export class Header extends BaseComponent {
  private title: string;
  private subtitle: string;
  private onClose?: () => void;
  private statusDot?: HTMLElement;

  constructor(title: string, subtitle = "", onClose?: () => void) {
    super();
    this.title = title;
    this.subtitle = subtitle;
    this.onClose = onClose;
    this.element = this.create();
  }

  protected create(): HTMLElement {
    const el = document.createElement("div");
    el.className = "ac-header";

    const info = document.createElement("div");
    info.className = "ac-header-info";

    // Status dot
    this.statusDot = document.createElement("span");
    this.statusDot.className = "ac-status-dot ac-status-online";
    this.statusDot.setAttribute("aria-label", "Online");

    const titleEl = document.createElement("span");
    titleEl.className = "ac-header-title";
    titleEl.textContent = this.title;

    info.appendChild(this.statusDot);
    info.appendChild(titleEl);

    if (this.subtitle) {
      const sub = document.createElement("span");
      sub.className = "ac-header-subtitle";
      sub.textContent = this.subtitle;
      info.appendChild(sub);
    }

    el.appendChild(info);

    if (this.onClose) {
      const closeBtn = document.createElement("button");
      closeBtn.className = "ac-header-close";
      closeBtn.setAttribute("aria-label", "Close");
      closeBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
      closeBtn.addEventListener("click", () => this.onClose!());
      el.appendChild(closeBtn);
    }

    return el;
  }

  public setStatus(status: "online" | "thinking" | "offline"): void {
    if (!this.statusDot) return;
    this.statusDot.className = `ac-status-dot ac-status-${status}`;
    this.statusDot.setAttribute("aria-label", status.charAt(0).toUpperCase() + status.slice(1));
  }
}
